export const SET_VIDEO_STREAMING_DATA = 'SET_VIDEO_STREAMING_DATA'
export const UPDATE_VIDEO_STREAMING_ITEM = 'UPDATE_VIDEO_STREAMING_ITEM'
